module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Gamepad2-f86c8f31df803ec820a8419f63003a2d.svg";